module.exports = __webpack_public_path__ + "img/crypto-ubd.2e9ba441.svg";